import React, { createContext, useContext } from 'react';
import type { RelatedEntity } from '../utils/entity-utils';
import type { MoveToNoteResult } from '../utils/note-utils';

export type HeadingSectionReferences = {
  linksTo: RelatedEntity[];
  referencedIn: RelatedEntity[];
};

export type ManualChapterMenuOption = {
  id: string;
  title: string;
  order?: number;
};

export type HeadingSectionMenuContextValue = {
  onAnalyzeSection: (from: number, to: number) => void;
  onChatAboutSection: (from: number, to: number) => void;
  onMoveToNote: ((content: string) => Promise<MoveToNoteResult>) | null;
  isAnalyzing: boolean;
  projectId: string | null;
  documentId: string | null;
  manualChapters: ManualChapterMenuOption[];
  getChapterReferencesForHeading: (headingTitle: string) => HeadingSectionReferences;
  getEffectiveManualChapterIdForHeading: (headingTitle: string) => string | null;
  hasUserLinkedManualChapter: (headingTitle: string) => boolean;
  linkHeadingToManualChapter: (headingTitle: string, manualChapterId: string) => Promise<boolean>;
  unlinkHeadingFromManualChapter: (headingTitle: string) => Promise<boolean>;
};

const emptyReferences: HeadingSectionReferences = { linksTo: [], referencedIn: [] };

const HeadingSectionMenuContext = createContext<HeadingSectionMenuContextValue | null>(null);

export const HeadingSectionMenuProvider = HeadingSectionMenuContext.Provider;

export function useHeadingSectionMenu(): HeadingSectionMenuContextValue | null {
  return useContext(HeadingSectionMenuContext);
}

export function emptyHeadingSectionReferences(): HeadingSectionReferences {
  return emptyReferences;
}
